import { render, staticRenderFns } from "./BrowseKosaku.vue?vue&type=template&id=15284849&scoped=true&"
import script from "./BrowseKosaku.vue?vue&type=script&lang=js&"
export * from "./BrowseKosaku.vue?vue&type=script&lang=js&"
import style0 from "./BrowseKosaku.vue?vue&type=style&index=0&id=15284849&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15284849",
  null
  
)

export default component.exports